module.exports = __webpack_public_path__ + "static/media/single.ffe38dca.svg";